var Common = {
  currentUser: JSON.parse(localStorage.getItem('userData')),
  account: JSON.parse(localStorage.getItem('accountData')),
  isOn: localStorage.getItem('isOn'),
  baseUrl: 'https://dev.cliniqueadmin.com/',
  baseApiUrl: 'https://dev.cliniqueadmin.com/api/'
};
export default Common;